<template>
  <v-app id="inspire">
      <div class="language-selector">
        <!-- <a href="" style="color:black;text-decoration: none;"> -->
        <span class="tran-btn" @click="changeLang(langSwitch)">{{ langSwitch }}</span>
          <!-- </a> -->
      </div>
    <v-content>
      <!-- <v-container class="fill-height" fluid> -->
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col md="12">
            <v-img
              src="./assets/images/nasket-logo.png"
              height="80"
              :contain="true"
            ></v-img>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline2 white--text" align="center"
                >{{welcomeTxt}}</v-list-item-title
              >
              <v-list-item-subtitle class="white--text" align="center"
                >{{applicationTxt}}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-row>
        <v-spacer></v-spacer>
        <v-row align="center" justify="center">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-row>
      </v-container>
    </v-content>
    <v-content>
      <v-row>
        <v-col class="text-center" cols="5" offset="1">
          <v-icon dark size="20">mdi-help</v-icon>
          <a
            href="http://www.nasket2.com/blog/faq-items/faq-logker/"
            style="color:white;"
            >{{faqTxt}}</a
          >
        </v-col>
        <v-col class="text-center" cols="5">
          <a href="https://line.me/R/ti/p/%40lrl4495e" style="color:white;"
            >{{helpTxt}}</a
          >
        </v-col>
      </v-row>
    </v-content>
  </v-app>
</template>
<style>
* {
  font-family: "Roboto", "Kanit", sans-serif !important;
}
.v-application .headline2 {
  font-size: 1.5rem !important;
  font-weight: 400;
  line-height: 2rem;
  font-family: "Roboto", "Kanit", sans-serif !important;
}
#inspire {
  background-color: #f67379 !important; /* override background color */
  background: url("./assets/images/bg-2.png") 50% 50% no-repeat;
  background-position-y: bottom;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#dialog-collect-title {
  background-color: #f67379;
}
#dialog-store-title {
  background-color: #ffa63e;
}
.v-card__text {
  /* padding: 0; */
}
.v-stepper {
  box-shadow: none !important;
}
.v-stepper__step {
  padding: 24px 0 24px !important;
}
.v-stepper__label {
  display: flex !important;
  text-align: center !important;
  line-height: 1.2 !important;
}
.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 100px !important;
}
.language-selector {
  text-align: right;
  padding: 4px 24px 4px 24px;
}
.tran-btn {
  padding: 8px;
  background-color: white;
}
</style>
<script>
export default {
  props: {
    source: String,
  },
  data() {
    return {
      langSwitch: 'EN',
      lang: 'th'
    };
  },
  mounted() {
    this.setLangFromCookie()
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    changeLang(lang) {
      document.cookie = "lang=" + lang.toLowerCase();
      this.$root.$emit("change lang");
      this.setLangFromCookie();
    },
    setLangFromCookie() {
      if (document.cookie.split(';').some((item) => item.includes('lang=th'))) {
        this.lang = 'th';
        this.langSwitch = 'EN';
      } else {
        this.lang = 'en';
        this.langSwitch = 'TH';
      }
    }
  },
  computed: {
    welcomeTxt: function() {
      return this.lang == 'th' ? 'ยินดีต้อนรับสู่' : 'Welcome!'
    },
    applicationTxt: function() {
      return this.lang == 'th' ? ' ระบบสมาร์ทล็อคเกอร์' : 'Smart Locker'
    },
    faqTxt: function() {
      return this.lang == 'th' ? ' คำถามที่พบบ่อย' : 'FAQ'
    },
    helpTxt: function() {
      return this.lang == 'th' ? ' ศูนย์ช่วยเหลือ' : 'Help Center'
    }
  }
};
</script>
